import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from 'services/axiosBaseQuery'
import { MutationResponse } from 'services/Engagement/types'
import { CreateWasteTypeRequest, WasteTypeListResponse } from './types'
import { sendNotification } from 'components'
import i18n from 'utils/i18n'
import { TableRequest } from 'services/types'

export const wasteAdministrationApi = createApi({
  reducerPath: 'wasteAdministrationApi',
  tagTypes: ['WasteTypes'],
  baseQuery: axiosBaseQuery({
    baseUrl: `${window.envVariables.REACT_APP_BASE_URL + '/int-api/settings/'}`,
  }),
  endpoints: (builder) => ({
    getWasteTypeList: builder.query<WasteTypeListResponse, TableRequest>({
      query: ({ clientId, ...data }) => ({
        url: `clients/${clientId}/waste_types/list/`,
        method: 'POST',
        data,
      }),
      providesTags: ['WasteTypes'],
    }),
    createWasteType: builder.mutation<MutationResponse, CreateWasteTypeRequest>({
      query: ({ client_id, body }) => ({
        url: `clients/${client_id}/waste_types/`,
        method: 'POST',
        data: body,
      }),
      invalidatesTags: ['WasteTypes'],
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          sendNotification({
            type: 'success',
            toastContent: data.detail.message || i18n.t('response.message.success'),
          })
        } catch (err) {}
      },
    }),
  }),
})

export const { useGetWasteTypeListQuery, useCreateWasteTypeMutation } = wasteAdministrationApi
